<script>
  import { Link } from "svelte-routing";
  import { _ } from '../services/i18n';
  import {
    Carousel,
    CarouselControl,
    CarouselIndicators,
    CarouselItem
  } from 'sveltestrap';
  import * as Constants from '../Constants';
  import * as Utils from '../services/Utils';

  let items = [];
  let loading = false;
  let error = false;
  let activeIndex = 0;

  function fetchItems() {
    loading = true;
    Utils.fetchData(Constants.HOST_SERVICES + 'getSliderNg')
        .then(response => response.json())
        .then(response => items = response.result)
        .catch(error => {
          error = true;
          console.error(error);
        })
        .finally(() => {
          loading = false;
        });
  }
  
  fetchItems();
</script>

<h1 id="home-title">Fantasy Meets Technology</h1>

<div id="container" class="fadeIn home">
  <div id="slider">
    <div id="sliderContent">
      <div class="carousel-inner">
        <Carousel {items} bind:activeIndex>
          <CarouselIndicators bind:activeIndex {items} />

          <div class="carousel-inner">
            {#each items as item, index}
              <CarouselItem bind:activeIndex itemIndex={index}>
                <img src={Constants.PUBLIC_SLIDERS_IMAGES + item.src + Constants.GALLERY_FILE_EXT} 
                class="d-block w-100" alt={`${item.name}${index + 1}`} />
              </CarouselItem>
            {/each}
          </div>

          <CarouselControl direction="prev" bind:activeIndex {items} />
          <CarouselControl direction="next" bind:activeIndex {items} />
        </Carousel>
      </div>
    </div>
  </div>

  <div id="second-region">
    <ul id="home-list">
      <li class="home-li">
        <Link to="/gallery-models">
        <div class="home-a">
          <div class="title">
            <span class="sprite_world list-dot"></span>
            {$_('menu.sez3dModels')}
            <span class="hrRight"></span>
          </div>
          <p>
            {$_('index.desc3dModels')}
          </p>
        </div>
        </Link>
      </li>
      <li class="home-li">
        <Link to="/gallery-websites">
        <div class="home-a">
          <div class="title">
            <span class="sprite_world list-dot"></span>
            {$_('menu.sezWebsites')}
            <span class="hrRight"></span>
          </div>
          <p>
            {$_('index.descWebsites')}
          </p>
        </div>
        </Link>
      </li>
      <li class="home-li">
        <Link to="/gallery-graphics">
        <div class="home-a">
          <div class="title">
            <span class="sprite_world list-dot"></span>
            {$_('menu.sezGraphics')}
            <span class="hrRight"></span>
          </div>
          <p>
            {@html $_('index.descGraphics')}
          </p>
        </div>
        </Link>
      </li>
      <li class="home-li">
        <Link to="/gallery-tools">
        <div class="home-a">
          <div class="title">
            <span class="sprite_world list-dot"></span>
            {$_('menu.sezTools')}
            <span class="hrRight"></span>
          </div>
          <p>
            {$_('index.descTools')}
          </p>
        </div>
        </Link>
      </li>
    </ul>
    <div id="right-list">
      <div id="right-img"></div>
    </div>
  </div>
</div>

<style type="text/scss">
@import '../../public/styles/variables';
@import '../../public/styles/mixins';

#home-title {
  margin: 0 auto;
  padding: 40px 0 20px;
  font-size: 60px;
  line-height: 60px;
  color: lighten(#455d82, 10%);
  font-variant: small-caps;
  font-family: 'Orbitron', 'Verdana', Arial, sans-serif;
  text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 -2px 30px #fff,
      0 -6px 40px #0089ff, 0 -6px 70px #ff00de, 0 -6px 80px #ff00de;
  -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)),
    color-stop(100%, rgba(0, 0, 0, .4)), to(rgba(0,0,0,1)));
  animation: moveUpDown 3.5s cubic-bezier(0.61, 0.1, 0.36, 0.84) infinite;

  @media #{$tablet-m} {
    padding: 30px 0 20px;
  }
  @media #{$tablet-s} {
    font-size: 36px;
    line-height: 36px;
    -webkit-mask-image: none;
  }
}
@keyframes moveUpDown {
  0% {
    -webkit-transform: translateY(7px);
    -ms-transform: translateY(7px);
    transform: translateY(7px);
  }
  50% {
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
  100% {
    -webkit-transform: translateY(7px);
    -ms-transform: translateY(7px);
    transform: translateY(7px);
  }
}

#container {
  margin-top: 0;
  padding-top: 0;
  max-width: 924px;
  &.home {
    min-height: 890px;
    @media #{$tablet-s} {
      min-height: 710px;
    }
  }

  .loading-background {
    min-height: 250px;
    min-width: 100%;
    background-color: transparentize(#00acc1, 0.5);
    .lds-css {
      position: absolute;
      z-index: -1;
      left: 38%;
    }
    @media #{$tablet-s} {
      min-height: 150px;
    }
  }
  div#slider {
    width: 100%;
    margin: 0 0 40px;
    padding: 6px;
    box-sizing: border-box;
    background-color: transparentize(darken($idro-palette-first, 5%), .7);
    @include border-radius(10%);
  }
  #border-left, #border-right {
    height: 100%;
    width: 30px;
    position: absolute;
    top: 0;
  }
  #border-left {
    background: $img-border-left repeat-y 100% 0;
    left: -20px;
  }
  #border-right {
    background: $img-border-right repeat-y 100% 0;
    right: -9px;
  }
  #second-region {
    position: relative;
    #home-list {
      width: 50%;
      float: left;
      font-size: 14px;
      .home-li {
        width: 100%;
        min-width: 190px;
        padding: 10px 20px;
        box-sizing: border-box;
        float: left;
        list-style: inside none;
        .home-a {
          height: 120px;
          padding: 10px;
          box-sizing: border-box;
          display: block;
          background-color: transparentize($idro-palette-first, 0.5);
          @include border-radius(10px);
          @include transition(all 0.3s ease-in-out);
          &:hover {
            @include box-shadow(1px 2px 10px 5px transparentize(white, 0.9));
            background-color: transparentize(lighten($idro-palette-second, 10%), 0.4);
          }
        }
        .title {
          color: #fff;
          display: block;
          font-size: 16px;
          font-family: $idro-font-family-title;
          letter-spacing: 2px;
          box-sizing: border-box;
          .list-dot {
            display: block;
            float: left;
            width: 17px;
            height: 11px;
            background-position: -258px -161px;
            margin: 3px 20px 0 0
          }
          .hrRight {
            width: 95%;
            height: 8px;
            border-bottom: 2px solid darken($idro-palette-first, 3%);
            margin: 0 auto 6px;
            display: block;
          }
        }
        p {
          color: $idro-palette-font-color;
          margin: 0 15px;
        }
      }

      @media #{$tablet-m} {
        width: 100%;
        .home-li {
          padding: 10px 10%;
          .home-a {
            height: 140px;
          }
        }
      }
    }

    #right-list {
      box-sizing: border-box;
      float: right;
      width: 49%;
      height: 558px;
      padding: 10px 20px 10px 0;
      #right-img {
        position: relative;
        border-radius: 22px;
        background-image: url("https://tools.obyte.it/img/idrobyte/render_youtube_facebook.min.jpg");
        background-position: -100px 0;
        background-size: auto 100%;
        border: 1px solid grey;
        display: block;
        width: 100%;
        height: 100%;
        animation: moveLeftRight 8s linear infinite;
      }
      @media #{$tablet-m} {
        display: none;
      }
    }

    @keyframes moveLeftRight {
      0% {
        background-position: 0 0;
      }
      100% {
        background-position: 772px 0;
      }
    }
  }

  /** LITTLE PC */
  @media #{$tablet-m} {
    div#slider {
      //width: 330px;
      margin: 0 auto 20px;
      div#sliderContent .carousel-caption h3 {
        font-size: 14px;
      }
    }
  }

  /** MOBILE */
  @media #{$mobile} {
    div#slider {
      margin: 0 auto;
      div#sliderContent .carousel-caption h3 {
        font-size: 14px;
      }
    }
  }
  @media #{$mobile-m} {
    div#slider {
      width: 100%;
    }
  }
}
</style>
